import type { ForqFeatureManifest, ForqModuleManifest } from '@forq/contracts';

export const machinesModule: ForqModuleManifest = {
  id: 'machines',
  name: 'Maschinen',
  description: 'Maschinenstamm, Kunden-Zuordnung und typabhängige technische Daten',
  version: '0.1.0',
  route: '/maschinen',
  category: 'masterdata',
  status: 'development',
  requiredPermissions: ['machines.view'],
  features: ['machines.list', 'machines.details', 'machines.create', 'machines.edit'],
  navigation: [
    { id: 'machines.primary', label: 'Maschinen', route: '/maschinen', placement: 'primary', order: 30, icon: 'maschinen' },
    { id: 'machines.launcher', label: 'Maschinen', route: '/maschinen', placement: 'launcher', order: 30, icon: 'maschinen' },
  ],
};

export const machinesFeatures: readonly ForqFeatureManifest[] = [
  {
    id: 'machines.list', moduleId: 'machines', name: 'Maschinenliste',
    description: 'Mandantenbezogene Suche und Filter', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['machines.view'], uiSlots: [], emits: ['machine.opened'], listensTo: ['tenant.changed'],
  },
  {
    id: 'machines.details', moduleId: 'machines', name: 'Maschinendetails',
    description: 'Stammdaten, Eigentümer und dynamische technische Felder', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['machines.view'], uiSlots: [], emits: [], listensTo: ['machine.opened'],
  },
  {
    id: 'machines.create', moduleId: 'machines', name: 'Maschine anlegen',
    description: 'Neue Maschine mit automatischer Erfassungsnummer anlegen', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['machines.create'], uiSlots: [], emits: ['machine.created'], listensTo: [],
  },
  {
    id: 'machines.edit', moduleId: 'machines', name: 'Maschine bearbeiten',
    description: 'Stammdaten, Zuordnung und technische Werte bearbeiten', version: '0.1.0', defaultEnabled: true,
    requiredPermissions: ['machines.edit'], uiSlots: [], emits: ['machine.updated'], listensTo: [],
  },
];
